import {
	cleanRoles,
	getAllRoleSuccess,
	getFilterRole,
	getFilterRoleError,
	getFilterRoleSuccess,
} from 'projects/access-control/src/app/Infrastructure/Store/role/role.actions';
import { IRole } from 'projects/access-control/src/app/Domain/Entities/roles/role.interface';
import { createReducer, on } from '@ngrx/store';
import { initialStateRole, RoleState } from 'projects/access-control/src/app/Infrastructure/Store/role/role.state';
import adapterDataPagination from '../../../Domain/Adapters/pagination.adapter';
import {
	deleteRole,
	deleteRoleError,
	deleteRoleSuccess,
	getRole,
	getRoleError,
	getRoleSuccess,
	postRole,
	postRoleError,
	postRoleSuccess,
	updateRole,
	updateRoleError,
	updateRoleSuccess,
} from './role.actions';
import { DataPagination } from 'projects/access-control/src/app/Domain/Adapters';
import { Pagination } from 'projects/access-control/src/app/Domain/Entities/pagination.interface';

export const RoleReducer = createReducer(
	initialStateRole,
	on(getRoleSuccess, (state, { role, pagination }) => ({
		...state,
		roles: role,
		pagination: adapterDataPagination(pagination),
		paginationInit: pagination,
		loading: false,
		error: null,
	})),
	on(getFilterRoleSuccess, (state, { role, pagination }) => ({
		...state,
		roles: role,
		pagination: adapterDataPagination(pagination),
		paginationInit: pagination,
		loading: false,
		error: null,
	})),
	on(getAllRoleSuccess, (state, { role }) => ({
		...state,
		roles: role,
		pagination: {} as DataPagination,
		paginationInit: {} as Pagination,
		loading: false,
		error: null,
	})),
	on(cleanRoles, (state) => ({
		roles: [],
		pagination: {} as DataPagination,
		paginationInit: {} as Pagination,
		loading: false,
	})),
	on(postRoleSuccess, (state, { role }) => ({
		...state,
		roles: [role, ...state.roles],
		pagination: adapterDataPagination(
			state.paginationInit,
			state.roles.length,
			+1,
			state.pagination.total,
			state.pagination.pageTo
		),
		loading: false,
		paginationInit: state.paginationInit,
		error: null,
	})),
	on(updateRoleSuccess, (state, { role }) => ({
		...state,
		loading: false,
		roles: state.roles.map((roleItem) =>
			roleItem.pk === role.pk && roleItem.sk === role.sk ? role : roleItem
		),
		error: null,
	})),
	on(deleteRoleSuccess, (state, { role }) => {
		const roles = [...state.roles];
		role.forEach((roleData) => {
			const indexRole = roles.findIndex(
				(roleItem) => roleItem.pk === roleData.pk && roleItem.sk === roleData.sk
			);
			roles.splice(indexRole, 1);
		});

		return {
			...state,
			loading: false,
			paginationInit: state.paginationInit,
			pagination: adapterDataPagination(
				state.paginationInit,
				state.roles.length,
				-role.length,
				state.pagination.total,
				state.pagination.pageTo
			),
			roles: roles,
			error: null,
		};
	}),
	on(
		getRoleError,
		deleteRoleError,
		postRoleError,
		updateRoleError,
		getFilterRoleError,
		(state, { error }) => ({
			...state,
			error: error.error.errorMessage,
			loading: false,
		})
	),
	on(getRole, deleteRole, postRole, updateRole, getFilterRole, (state) => ({
		...state,
		loading: true,
	}))
);
